import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefone'
})
export class TelefonePipe implements PipeTransform {

  transform(value: string | number): string {
    const raw = value?.toString().replace(/\D/g, '');

    if (!raw || raw.length < 10) {
      return value?.toString() || '';
    }

    // Formata para (00) 0 0000-0000
    return raw.replace(/^(\d{2})(\d{1})(\d{4})(\d{4}).*/, '($1) $2 $3-$4');
  }

}
